module.exports = __webpack_public_path__ + "static/media/nextsectionimg.dd590561.png";